'use client';

import { Children, cloneElement } from 'react';

import { usePopperContext } from './hooks';

import type { FC, ReactElement } from 'react';

export interface ToggleProps {
  children: ReactElement;
}

export const PopperToggle: FC<ToggleProps> = ({ children, ...props }) => {
  const { handleToggle } = usePopperContext();

  return (
    <>
      {Children.map( children, (child, index) =>
        cloneElement( child, {
          key: index,
          onClick: handleToggle,
          ...props,
        } ) )}
    </>
  );
};
